import React from 'react';

interface IconTextProps {
    icon: React.ReactNode;
    text: string;
}

const IconText: React.FC<IconTextProps> = ({ icon, text }) => {
    return (
       <p className="font-regular text-[20px] tracking-[0.05em] uppercase text-grey-800 flex items-cente max-[576px]:text-[16px]">
            <span className="mr-3">{icon}</span>
            {text}
        </p>
    )
}

export default IconText